import { AdminShipment } from "@/model/transportorder/transportOrder"

import { State } from "./store"

export const getSelectedAdminTransportOrder
    = (store: State): AdminShipment | undefined => store.adminUi.selectedTransportOrder
